// Changing status for applications
$(".btn-status-accept").click(function (e) {
    e.preventDefault();

    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "application-accepted") {
                var status_cell = button.closest('tr').find('.status-info');
                status_cell.text('Прийнято');
                status_cell.removeClass('text-warning').removeClass('text-danger').addClass('text-success');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});

$(".btn-status-decline").click(function (e) {
    e.preventDefault();

    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "application-declined") {
                var status_cell = button.closest('tr').find('.status-info');
                status_cell.text('Відхилено').removeClass('text-warning').removeClass('text-success').addClass('text-danger');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});

// Changinge status for candidates
$(".btn-candidate-activate").click(function (e) {
    e.preventDefault();

    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "candidate-activated") {
                var status_cell = button.closest('tr').find('.status-candidate');
                status_cell.text('Активний').removeClass('text-danger').addClass('text-success');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});

$(".btn-candidate-deactivate").click(function (e) {
    e.preventDefault();

    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "candidate-deactivated") {
                var status_cell = button.closest('tr').find('.status-candidate');
                status_cell.text('Знятий').removeClass('text-success').addClass('text-danger');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});